import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ArrowRight, Zap } from 'lucide-react';

const HeroSection = () => {
  const goToRegister = () => {
    // Navigate to local server registration page
    window.location.href = '/register.html';
  };

  return (
    <section id="home" className="py-20 md:py-32 text-center relative overflow-hidden min-h-[calc(100vh-5rem)] flex flex-col justify-center items-center">
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/4 left-1/4 w-1/2 h-1/2 bg-neon-purple rounded-full filter blur-3xl animate-pulse"></div>
        <div className="absolute top-1/3 right-1/4 w-1/3 h-1/3 bg-neon-blue rounded-full filter blur-3xl animate-pulse animation-delay-2000"></div>
        <div className="absolute bottom-1/4 left-1/3 w-1/4 h-1/4 bg-neon-pink rounded-full filter blur-3xl animate-pulse animation-delay-4000"></div>
      </div>
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="relative z-10 max-w-3xl mx-auto"
      >
        <motion.h1 
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-8 bg-clip-text text-transparent bg-gradient-to-r from-neon-pink via-neon-purple to-neon-blue animate-bg-pan"
          style={{ WebkitTextStroke: '1px rgba(255,255,255,0.1)' }}
        >
          Connecting Advertisers to Global Traffic
        </motion.h1>
        <motion.p 
          className="text-lg md:text-xl text-cyber-text-secondary mb-12 max-w-2xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Unlock high-quality global traffic with AI-driven insights plus human verification. Our platform fine-tunes your ad delivery to reach the right audiences, reduce wasted ad spend, and boost overall performance.
        </motion.p>
        <motion.div 
          className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <Button 
            size="lg" 
            className="w-full sm:w-auto bg-gradient-to-r from-neon-pink to-neon-purple text-white text-lg font-semibold py-3 px-8 rounded-lg shadow-neon-md-pink hover:shadow-neon-lg-pink transition-all duration-300 transform hover:scale-105 group"
            onClick={goToRegister}
          >
            Sign Up Now <ArrowRight className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform" />
          </Button>
          <Button 
            size="lg" 
            variant="outline" 
            className="w-full sm:w-auto border-2 border-neon-blue text-neon-blue text-lg font-semibold py-3 px-8 rounded-lg shadow-neon-sm-blue hover:bg-neon-blue/20 hover:shadow-neon-md-blue transition-all duration-300 transform hover:scale-105 group"
            onClick={goToRegister}
          >
            Become an Advertiser <Zap className="ml-2 h-5 w-5 text-neon-blue group-hover:animate-ping transition-transform" />
          </Button>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
